var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.9999L6 13.9999M6 13.9999L9.956 17.9559C10.0716 18.0714 10.2138 18.1568 10.37 18.2046C10.5263 18.2524 10.6919 18.2613 10.8523 18.2303C11.0127 18.1993 11.1631 18.1295 11.2903 18.0269C11.4176 17.9243 11.5177 17.7922 11.582 17.6419L13.837 12.3809C13.8887 12.2601 13.9637 12.1507 14.0578 12.0589C14.1518 11.9671 14.263 11.8947 14.385 11.8459L17.592 10.5629C17.7456 10.5015 17.8815 10.4029 17.9876 10.276C18.0937 10.1491 18.1666 9.99786 18.1999 9.83584C18.2332 9.67383 18.2258 9.50608 18.1784 9.34763C18.1309 9.18918 18.0449 9.04498 17.928 8.92794L11.072 2.07194C10.955 1.95506 10.8108 1.86904 10.6523 1.82159C10.4939 1.77413 10.3261 1.76672 10.1641 1.80001C10.0021 1.83331 9.85085 1.90627 9.72395 2.01237C9.59706 2.11846 9.49846 2.25438 9.437 2.40794L8.154 5.61494C8.1052 5.73695 8.03284 5.84815 7.94104 5.94218C7.84924 6.03621 7.73981 6.11123 7.619 6.16294L2.358 8.41794C2.20778 8.48224 2.07561 8.58238 1.97304 8.70959C1.87048 8.8368 1.80065 8.9872 1.76967 9.14764C1.73868 9.30808 1.74749 9.47367 1.79531 9.62992C1.84314 9.78617 1.92852 9.92832 2.044 10.0439L6 13.9999Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOutlined);
export default __webpack_public_path__ + "static/media/pin_outlined.83fac51e60c1209f5c196dcd84c55b08.svg";
export { ForwardRef as ReactComponent };